module.exports = __webpack_public_path__ + "img/shop.4a6b634e.png";